export const API_ENDPOINTS = {
  EMARKETING_SENT: {
    Summary: '/emarketing/sent',
    Details: '/emarketing/sent/details',
    Delete: '/emarketing/sent/details/{id}',
    Bulk: '/emarketing/sent/details/bulk',
    Send: '/emarketing/sent/send',
    GetById: '/emarketing/sent/get-by-id/{id}',
  },
};
